const storage = localStorage;
const key     = 'last_view';

// -----------------------------------------------------
// Util Definition
// -----------------------------------------------------

const ViewToken = {
  read:   () => storage.getItem(key),
  write:  (lastView) => storage.setItem(key, lastView),
  remove: () => storage.removeItem(key)
};

// -----------------------------------------------------
// Exports
// -----------------------------------------------------

export default ViewToken;